import { fetchGetJson, fetchPost } from "../../utils/fetch-json.js";

export enum FollowType {
  Follower = "follower",
  Following = "following"
}

export const FollowService = {
  follow: (userId: string) => fetchPost(`/v1/u/${userId}/follow`),

  unfollow: (userId: string) => fetchPost(`/v1/u/${userId}/unfollow`),

  getFollowers: (userId: string) => fetchGetJson(`/v1/u/${userId}/followers`),

  getFollowings: (userId: string) => fetchGetJson(`/v1/u/${userId}/followings`)
};
